<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <!-- Page Content -->
    <div class="content container-fluid">
      <!-- Page Header -->
      <add-schedule-header :title="title" :path="path" :text="text" :text1="text1" @addScheduleClick="addScheduleClick"/>
      <!-- /Page Header -->

      <!-- Search Filter -->
      <!-- <search-filter @searchClicked="searchClicked"></search-filter> -->
      <!-- /Search Filter -->

      <div class="floating-search-container" :class="{ 'expanded': searchFocused || searchQuery !== '' }" v-if="scheduleData && scheduleData.length">
        <div class="search-wrapper">
          <input v-show="searchFocused || searchQuery !== ''" type="text" ref="searchInput" v-model="searchQuery"
            @focus="searchFocused = true"
            @blur="searchFocused = false"
            class="search-input-field"
            placeholder="Search by name..." />
          <div class="search-icon-btn" @click="toggleSearch">
            <i v-if="!searchQuery" class="fa-solid fa-magnifying-glass text-muted"></i>
            <i v-else @click.stop="clearSearch" class="fa-solid fa-circle-xmark text-muted"></i>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="showentries mb-3 custom-select">
            <div class="d-flex align-items-center gap-2"><span>Show</span>
              <select v-model="perPage" @change="current = 1; getUsers()" style="outline: none">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <span>entries</span></div>
          </div>
          <div v-if="!loader">
          <div class="table-responsive">
            
            <a-table class="stripped table-hover" :columns="columns" :data-source="filteredSchedules" :pagination="false" v-if="scheduleData">
              <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'name'">
                  
                    {{ record.name}}
                </template>
                <template v-else-if="column.key === 'role_count'">
                    {{ record.role_count }}
                </template>
                 <template v-else-if="column.key === 'user_count'">
                    {{ record.user_count }}
                </template>
                <template v-else-if="column.key === 'action'">
                  <div>
                    <div class="dropdown dropdown-action">
                      <a href="javascript:;" class="action-icon dropdown-toggle" data-bs-toggle="dropdown"
                        aria-expanded="false"><i class="material-icons">more_vert</i></a>
                      <div class="dropdown-menu dropdown-menu-right">
                          <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                          data-bs-target="#add_schedule" @click="viewClicked(record)"><i
                            class="fa fa-eye m-r-5"></i> View</a>  
                         <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                          data-bs-target="#add_schedule" @click="editClicked(record)"><i
                            class="fa-solid fa-pencil m-r-5"></i> Edit Template</a>
                         <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                          data-bs-target="#edit-schedule-template-user" @click="addUsersClicked(record)"><i
                            class="fa-solid fa-user-pen m-r-5"></i>Add/Remove Users</a> <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                          data-bs-target="#edit-schedule-template-roles" @click="addRolesClicked(record)">
                          <i class="fa-solid fa-clipboard-user m-r-5"></i> Add/Remove Roles</a>
                       <!-- <a class="dropdown-item" href="javascript:;" @click="leavesClicked(record)"><i
                            class="fa-solid fa-arrow-left m-r-5"></i> Leaves</a> -->      
                        <!-- <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                          data-bs-target="#face_template" @click="addFaceTemplateClicked(record)"><i
                            class="fa-solid fa-plus m-r-5"></i>Add Face Template</a> -->
                        <!-- <a class="dropdown-item" href="javascript:;" data-bs-toggle="modal"
                          data-bs-target="#delete_employee"><i class="fa-regular fa-trash-can m-r-5"></i> Delete</a> -->
                      </div>
                    </div>
                  </div>
                </template>
              </template>
            </a-table>
             <div v-else>
              <div class="card text-center">
                <div class="card-body">
                  <img src="../../../assets/img/avatar/no-data.png" alt="no-data" srcset="" class="responsive-img">
                  <p>No employee have been added.</p>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <a-pagination v-model:current="current" v-model:pageSize="perPage" :total="total" @change="getUsers"
                show-less-items class="mt-3 "  :showSizeChanger="false">
                <template #itemRender="{ type, originalElement }">
                  <a v-if="type === 'prev'">Previous</a>
                  <a v-else-if="type === 'next'">Next</a>
                  <component :is="originalElement" v-else></component>
                </template>
              </a-pagination>
            </div>
            </div>
           
          </div>
           <div class="d-flex justify-content-center text-center mt-5" v-else>
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->

    <!-- <employee-modal @userAdded="getUsers"></employee-modal>-->
     <edit-schedule-template-user-modal ref="editScheduleUsers" @editedShift="getUsers"></edit-schedule-template-user-modal>
     <edit-role-modal ref="editScheduleRoles" @editedShift="getUsers"></edit-role-modal>
     <add-shift-schedule-modal ref="addSchedule" @editedShift="getUsers"></add-shift-schedule-modal>
    <!--<add-face-template-modal ref="addface"></add-face-template-modal> -->
  </div>
  <!-- /Page Wrapper -->
</template>

<script>
import axios from 'axios';
import {VUE_APP_API_BASE_URL} from "../../../config";
import { getImage } from "@/utils/util-funcitons";
const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: {
      compare: (a, b) => {
        a = a.name.toLowerCase();
        b = b.name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Roles",
    dataIndex: "role_count",
    key: "role_count"
  },
   {
    title: "Users",
    dataIndex: "user_count",
    key: "user_count"
  },
  {
    title: "Action", 
    // sorter: true,
    key: "action",
  },
];

export default {
  data() {
    return {
      columns,
      title: "Schedules",
      path: "Dashboard",
      text: "Schedules",
      text1: "Add Schedule",
      scheduleData: [],
      perPage: 100,
      current: 1,
      total: 0,
      employee_code: "",
      employee_name: "",
      loader:false,
      searchQuery: "",
      searchFocused: false
    };
  },
  mounted() {
    this.getUsers()
  },

  methods: {
    // searchClicked(data) {
    //   this.employee_code = data.employee_code;
    //   this.employee_name = data.employee_name;
    //   this.company_role_id = data.company_role_id;
    //   this.getUsers();
    // },
    getImage,
    getUsers() {
      this.loader = true;
      if(Number(this.perPage) >= this.total){
              this.current = 1
      }
      const params = {
        per_page: this.perPage
      //   employee_code: this.employee_code,
      //   employee_name: this.employee_name,
      //   company_role_id: this.company_role_id
      }
      axios.get(`${VUE_APP_API_BASE_URL}/schedule-template/get?page=${this.current}`, { params: params })
        .then((response) => {
      
          if (response.data.status) {
            this.scheduleData = response.data.data.data;
          
            this.current = response.data.data.current_page;
            
            this.total = response.data.data.total;
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

    leavesClicked(record){
      this.$router.push({ path: '/employee/leaves-employee', query: { id: record.id } })
    },

    // attendanceClicked(record){
    //   this.$router.push({ path: '/employee/attendance-employee', query: { id: record.id } })
    //   console.log(record.id);
    // },
    viewClicked(record) {
      this.$refs.addSchedule.showView(record.id);
    },
     editClicked(record) {
      this.$refs.addSchedule.editView(record.id);
    },
    addUsersClicked(record){
      this.$refs.editScheduleUsers.updateId(record.id);
    },
    addRolesClicked(record){
      this.$refs.editScheduleRoles.updateId(record.id);
    },
    addScheduleClick() {
      this.$refs.addSchedule.show();
    },
    toggleSearch() {
      if (this.searchFocused || this.searchQuery !== '') {
        this.$refs.searchInput.focus();
      } else {
        this.searchFocused = true;
        this.$nextTick(() => {
          this.$refs.searchInput.focus();
        });
      }
    },
    clearSearch() {
      this.searchQuery = '';
      this.$nextTick(() => {
        this.$refs.searchInput.focus();
      });
    }
  },
  computed: {
    filteredSchedules() {
      if (!this.searchQuery) {
        return this.scheduleData;
      }
      const query = this.searchQuery.toLowerCase().trim();
      return this.scheduleData.filter(item => item.name && item.name.toLowerCase().includes(query));
    }
  }
};
</script>
<style scoped>
:where(.css-dev-only-do-not-override-1hsjdkk).ant-pagination .ant-pagination-prev,
:where(.css-dev-only-do-not-override-1hsjdkk).ant-pagination .ant-pagination-next {
  background-color: #ffffff00 !important;
}

.inline-item {
  display: inline-block;
  margin-right: 2px;
  /* Adjust spacing between items */
}

.table-responsive{
    height: 100vh;
}

.responsive-img {
  width: 100%;
  max-width: 100px;
  height: auto;
}

.custom-select select {
  appearance: none;
    width: 50px;
    font-size: 14px;
    padding: 2px 5px;
    background-color: #fff;
    border: 1px solid #caced1;
    border-radius: 0.25rem;
    color: #000;
    cursor: pointer;
}

.floating-search-container {
  position: fixed;
  top: 95px;
  right: 30px;
  z-index: 1050;
  width: 40px;
  height: 40px;
  background: #ffffff;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border: 1px solid #e0e0e0;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  overflow: hidden;
}

.floating-search-container.expanded {
  width: 250px;
  border-radius: 6px;
}

.floating-search-container:hover {
  box-shadow: 0 6px 25px rgba(0, 0, 0, 0.2);
}

.search-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.search-input-field {
  width: 100%;
  height: 100%;
  border: none !important;
  outline: none !important;
  padding: 8px 40px 8px 12px !important;
  background: transparent;
  font-size: 14px;
  color: #333333;
}

.search-icon-btn {
  width: 38px;
  height: 38px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.floating-search-container.expanded .search-icon-btn {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  height: auto;
}

.search-icon-btn i {
  font-size: 16px;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
}

.search-icon-btn:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
